import { getSRPSuggestionUrl, patchUrlByLocale } from 'utils';
import { navigate } from './utils';
import { State } from 'store/types';
import { StoreonDispatch } from 'storeon';
import { SearchHistoryItem } from '../use-search-history-context';
import { ProductRedirectionEvents } from 'actions';

type Params = {
  productRedirectionUrl: string | null | undefined;
  dispatch: StoreonDispatch<State>;
  setIsSubmitted: React.Dispatch<React.SetStateAction<boolean>>;
  collapse: () => void;
  addHistoryItem: (item: SearchHistoryItem) => void;
  value: string;
  sanitizedValue: string;
  searchHref: string;
};

export const handleLmCode = ({
  productRedirectionUrl,
  dispatch,
  setIsSubmitted,
  collapse,
  addHistoryItem,
  value,
  sanitizedValue,
  searchHref,
}: Params) => {
  const searchFallbackUrl = getSRPSuggestionUrl(searchHref, sanitizedValue, false);
  const patchedUrl = productRedirectionUrl
    ? patchUrlByLocale({ url: productRedirectionUrl })
    : searchFallbackUrl;
  navigate(patchedUrl);
  setIsSubmitted(false);
  collapse();
  addHistoryItem({ title: value, url: patchedUrl });
  if (productRedirectionUrl) {
    dispatch(ProductRedirectionEvents.refresh);
  }
};
